import React, { useState } from 'react';
import { Plus, Edit, Check, X } from 'lucide-react';
import { CaseType, ActiveStatus } from '../types/masterData';
interface CaseTypeListProps {
  caseTypes: CaseType[];
  onSave: (type: CaseType) => void;
}
export function CaseTypeList({
  caseTypes,
  onSave
}: CaseTypeListProps) {
  const [editingId, setEditingId] = useState<string | null>(null);
  const [editForm, setEditForm] = useState<Partial<CaseType>>({});
  const [isAdding, setIsAdding] = useState(false);
  const handleEdit = (type: CaseType) => {
    setEditingId(type.id);
    setEditForm(type);
    setIsAdding(false);
  };
  const handleAdd = () => {
    setEditingId('new');
    setEditForm({
      id: `type-${Date.now()}`,
      name: '',
      description: '',
      status: 'Active'
    });
    setIsAdding(true);
  };
  const handleSave = () => {
    if (editForm.name && editForm.id) {
      onSave(editForm as CaseType);
      setEditingId(null);
      setIsAdding(false);
    }
  };
  const handleCancel = () => {
    setEditingId(null);
    setIsAdding(false);
  };
  return <div className="space-y-6 max-w-5xl mx-auto" data-id="element-168" data-mp="rn193ruyxm7v">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-169" data-mp="wlvv12o8fqw7">
        <div data-id="element-170" data-mp="hwpy5lcvacrh">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-171" data-mp="hx7you6kbd57">Case Types</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-172" data-mp="mvj6kzdardks">Manage incident classifications and types</p>
        </div>
        <button onClick={handleAdd} disabled={isAdding} className="flex items-center gap-2 px-4 py-2 bg-blue-800 text-white text-sm font-medium rounded-md hover:bg-blue-900 transition-colors disabled:opacity-50" data-id="element-173" data-mp="8v8i22zgmb2s">
          <Plus size={16} data-id="element-174" data-mp="3v3rmwswsl3k4" />
          Add Case Type
        </button>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-175" data-mp="3wf0nzh1xzxc">
        <div className="overflow-x-auto" data-id="element-176" data-mp="1tbuywjtfu18g">
          <table className="w-full text-left border-collapse" data-id="element-177" data-mp="1tcwlnljtgc60">
            <thead data-id="element-178" data-mp="1yb7xg1to8wqv">
              <tr className="bg-gray-50 border-b border-gray-200 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-179" data-mp="1y9n1q8vmf7rf">
                <th className="px-6 py-4 w-1/4" data-id="element-180" data-mp="1wuu3h3pw1fk8">Name</th>
                <th className="px-6 py-4 w-1/2" data-id="element-181" data-mp="1ru6f6pt1nctp">Description</th>
                <th className="px-6 py-4 w-1/6 text-center" data-id="element-182" data-mp="1rwsk0hojve88">Status</th>
                <th className="px-6 py-4 w-1/12 text-center" data-id="element-183" data-mp="1mvv2m7bd6o7s">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-184" data-mp="1ivkr6f4sz5lj">
              {isAdding && <tr className="bg-blue-50" data-id="element-185" data-mp="2fjiij91owqo3">
                  <td className="px-6 py-4" data-id="element-186" data-mp="2al7ddbmcb4c7">
                    <input autoFocus type="text" value={editForm.name || ''} onChange={e => setEditForm({
                  ...editForm,
                  name: e.target.value
                })} placeholder="Type Name" className="w-full border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-187" data-mp="2alh3r0bardif" />
                  </td>
                  <td className="px-6 py-4" data-id="element-188" data-mp="2yb1nhlf9yesr">
                    <input type="text" value={editForm.description || ''} onChange={e => setEditForm({
                  ...editForm,
                  description: e.target.value
                })} placeholder="Description" className="w-full border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-189" data-mp="2yc2y5osdoz9y" />
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-190" data-mp="kzgpvjctz5mu">
                    <select value={editForm.status || 'Active'} onChange={e => setEditForm({
                  ...editForm,
                  status: e.target.value as ActiveStatus
                })} className="border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-191" data-mp="l238qf5697kd">
                      <option value="Active" data-id="element-192" data-mp="z019ghqkl5he">Active</option>
                      <option value="Inactive" data-id="element-193" data-mp="yzi1ntumvxh3">Inactive</option>
                    </select>
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-194" data-mp="13x9pocs5qzg0">
                    <div className="flex items-center justify-center gap-2" data-id="element-195" data-mp="18pkspoi731cs">
                      <button onClick={handleSave} className="p-1 text-green-600 hover:bg-green-100 rounded" title="Save" data-id="element-196" data-mp="1cr6c7sp8idvy"><Check size={18} data-id="element-197" data-mp="1hqrd48nyswbb" /></button>
                      <button onClick={handleCancel} className="p-1 text-gray-500 hover:bg-gray-200 rounded" title="Cancel" data-id="element-198" data-mp="1hs2gw8heu42f"><X size={18} data-id="element-199" data-mp="1mq40qvmnu7ey" /></button>
                    </div>
                  </td>
                </tr>}
              {caseTypes.map(type => <tr key={type.id} className="hover:bg-gray-50" data-id="element-200" data-mp="142qzambmrgtn">
                  {editingId === type.id ? <>
                      <td className="px-6 py-4" data-id="element-201" data-mp="1irwzacialb2l">
                        <input autoFocus type="text" value={editForm.name || ''} onChange={e => setEditForm({
                    ...editForm,
                    name: e.target.value
                  })} className="w-full border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-202" data-mp="1dtbudzs3i37t" />
                      </td>
                      <td className="px-6 py-4" data-id="element-203" data-mp="l6r472ncvx5u">
                        <input type="text" value={editForm.description || ''} onChange={e => setEditForm({
                    ...editForm,
                    description: e.target.value
                  })} className="w-full border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-204" data-mp="102qaq8uthp8v" />
                      </td>
                      <td className="px-6 py-4 text-center" data-id="element-205" data-mp="2bfiyl8khltjn">
                        <select value={editForm.status || 'Active'} onChange={e => setEditForm({
                    ...editForm,
                    status: e.target.value as ActiveStatus
                  })} className="border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-206" data-mp="26j29ab1jx94z">
                          <option value="Active" data-id="element-207" data-mp="2j1wmot4346dm">Active</option>
                          <option value="Inactive" data-id="element-208" data-mp="251dftpbcv6d1">Inactive</option>
                        </select>
                      </td>
                      <td className="px-6 py-4 text-center" data-id="element-209" data-mp="293qiu5ypwq64">
                        <div className="flex items-center justify-center gap-2" data-id="element-210" data-mp="2ws9pyi616wwm">
                          <button onClick={handleSave} className="p-1 text-green-600 hover:bg-green-100 rounded" title="Save" data-id="element-211" data-mp="2wucpptwzk4ej"><Check size={18} data-id="element-212" data-mp="31tgwyf0cns28" /></button>
                          <button onClick={handleCancel} className="p-1 text-gray-500 hover:bg-gray-200 rounded" title="Cancel" data-id="element-213" data-mp="2nywr6zlad12m"><X size={18} data-id="element-214" data-mp="2s0i069up8v7j" /></button>
                        </div>
                      </td>
                    </> : <>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-215" data-mp="3kiducrr1n0oo">
                        <span className="text-sm font-medium text-gray-900" data-id="element-216" data-mp="3kjoy4rkho8fs">{type.name}</span>
                      </td>
                      <td className="px-6 py-4" data-id="element-217" data-mp="3qciozbeeud1s">
                        <span className="text-sm text-gray-500" data-id="element-218" data-mp="3qcr3t8u3fsfm">{type.description}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-219" data-mp="3lbbkbl7kdtzc">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${type.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-220" data-mp="3gda1n1e1vwoe">
                          {type.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-221" data-mp="32n6hcfyqed1l">
                        <button onClick={() => handleEdit(type)} className="p-1.5 bg-blue-100 text-blue-600 rounded hover:bg-blue-200 transition-colors" title="Edit" data-id="element-222" data-mp="2xomu8c8eiv7n">
                          <Edit size={16} data-id="element-223" data-mp="2npny1t4tos1j" />
                        </button>
                      </td>
                    </>}
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}